import axios from 'axios';


export const getCartItems = (userId) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/order/cart/shoppingcartlists/${userId}`)
        .then(e => e);
};


export const getDeliveryAddreslist = (cart) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/patient/deliveryaddress/list?user_uuid=${cart.cartId}&search=`).then(e => e);
};

export const getRelativeList = (userId) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/patient/consumer/${userId}`).then(e => e);
};


export const updateRecipient = async (userId, cartItemId, patientId, city, area, cartId) => {

    let response = await axios.put(`${process.env.REACT_APP_API_URL}/order/cart/shoppingcartlistpatient/${userId}/${cartItemId}/${patientId}/${area}/${city}/${cartId}`)
    if (response && (response.status === 200 || response.status === 201)) {
        return response;
    }
    throw new Error("Failed");
}


export const updateCart = async (updatedData, cartId, address) => {
    let payLoad = {
        data: [...new Set(updatedData)],
        deliveryAddress: address
    }
    let response = await axios.put(`${process.env.REACT_APP_API_URL}/order/cart/shoppingcart/list/update?cart_uuid=${cartId}`, payLoad)
    if (response && (response.status === 200 || response.status === 201)) {
        return response;
    }
    throw new Error("Failed");
}


export const deleteCartItem = async (userId, cartId, itemId, itemAmount, patientId) => {

    let response = await axios.delete(`${process.env.REACT_APP_API_URL}/order/cart/remove/${userId}?uuid=${cartId}&item_uuid=${itemId}&amount=${itemAmount}&patient_uuid=${patientId}`)
    if (response && (response.status === 200 || response.status === 201)) {
        return response;
    }
    throw new Error("Failed");
}



export const addAddress = async (userId, cartId, AddressData) => {

    const payLoad = AddressData
    let response = await axios.post(`${process.env.REACT_APP_API_URL}/patient/deliveryaddress`, payLoad)
    if (response && (response.status === 200 || response.status === 201)) {
        return response;
    }
    throw new Error("Failed");
}

export const editAddress = async (patientId, userId, payLoad) => {
    let response = await axios.put(`${process.env.REACT_APP_API_URL}/patient/updateDeliveryAddress/${patientId}/${userId}`, payLoad)
    if (response && (response.status === 200 || response.status === 201)) {
        return response;
    }
    throw new Error("Failed");
}

export const deleteAddress = async (cartId, patientId) => {

    let response = await axios.delete(`${process.env.REACT_APP_API_URL}/patient/deliveryaddress/${cartId}`)
    if (response && (response.status === 200 || response.status === 201)) {
        return response;
    }
    throw new Error("Failed");
}

